import React from 'react'
import { Trans } from '@lingui/react'
import CenterBox from './CenterBox.js'

const HomePage = () => (
  <CenterBox>
    <Trans>
      <p>Use the link in your e-mail to answer a survey.</p>
      <p>
        Visit <a href="https://remente.com">remente.com</a> for more information
        and inquiries.
      </p>
    </Trans>
  </CenterBox>
)

export default HomePage



// WEBPACK FOOTER //
// ./src/components/HomePage.js